import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { jsxs as e, Fragment as o, jsx as t } from "react/jsx-runtime";
import n, { css as r } from "styled-components";
import { AccessibilityTokens as a } from "@vds-tokens/accessibility";
import { ColorTokens as i } from "@vds-tokens/color";
import { Fonts as l } from "@vds-core/typography";
import { TypographyTokens as s } from "@vds-tokens/typography";
import { calculateRem as c } from "@vds-core/utilities";
var d = i.elements.primary.onlight.value,
  u = i.elements.primary.ondark.value,
  p = s.fontweight.bold.value,
  f = r(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  display: block;\n  font-family: ", ";\n  font-size: ", "; // TODO: Viewport awareness?\n  line-height: ", ";\n  text-decoration: none;\n  width: 100%;\n  position: relative;\n  -webkit-tap-highlight-color: transparent;\n  ", "\n  &:active,\n  &:hover {\n    outline: none;\n    span {\n      outline: none;\n    }\n  }\n  ", ";\n"])), function (_ref) {
    var e = _ref.surface;
    return "dark" === e ? u : d;
  }, l.VerizonNHGeTX, s.fontsize.body[12].value, s.lineheight.body[16].value, function (_ref2) {
    var e = _ref2.surface;
    return "\n    &:focus:not(:hover) {\n        outline: none;\n        span {\n          &::after {\n            border: ".concat(c(a.focusring.borderwidth.value), " ").concat(a.focusring.borderstyle.value, ";\n            border-color: ").concat("dark" === e ? a.color.focusring.ondark.value : a.color.focusring.onlight.value, ";\n            border-radius: ").concat(c(2), ";\n            content: '';\n            position: absolute;\n            height: 20px;\n            width: calc(100% + ").concat(c(parseInt(a.focusring.space.offset.value, 10) + parseInt(a.focusring.borderwidth.value, 10)), ");\n          }\n        }\n      }\n    &:not(:hover):not(:focus-visible) {\n      span {\n        &::after {\n          border: 0;\n        }\n      }\n    }\n  ");
  }, function (_ref3) {
    var e = _ref3.$active;
    return e && "\n    cursor: auto;\n    outline: none;\n    font-weight: ".concat(p, ";\n  ");
  }),
  h = n.a.withConfig({
    displayName: "StyledLink",
    componentId: "VDS__sc-3opay5-0"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), f),
  v = n.button.withConfig({
    displayName: "StyledButton",
    componentId: "VDS__sc-3opay5-1"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), f),
  g = n.span.withConfig({
    displayName: "ScreenReaderText",
    componentId: "VDS__sc-3opay5-2"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"]))),
  m = function m(n) {
    var r = n.baseUrl,
      a = n.children,
      i = n.selectedPage,
      l = n.linkStyles,
      s = n.onClick,
      c = n.pageNumber,
      d = n.cta,
      u = n.position,
      p = n.level,
      f = n.dataTrack,
      m = n.surface,
      b = n.total,
      y = i === c,
      k = r && c && !y ? r(c) : void 0,
      $ = {
        $active: y,
        surface: m,
        "aria-label": n["aria-label"] ? n["aria-label"] : y ? "Page ".concat(c, " of ").concat(b) : "Go to Page ".concat(c, " of ").concat(b),
        href: k,
        role: y ? "none" : r ? "link" : "button",
        style: l,
        onClick: y ? void 0 : k ? r : function (e) {
          "click" === e.type && (e.preventDefault(), null == s || s(c, e));
        },
        onKeyDown: y ? void 0 : k ? r : function (e) {
          "Enter" !== e.key && "click" !== e.type && " " !== e.key || (e.preventDefault(), null == s || s(c, e));
        },
        tabIndex: 0,
        "aria-current": y,
        "data-sitecat-cta": d,
        "data-sitecat-position": u,
        "data-sitecat-level": p,
        "data-sitecat-datatrack": f
      },
      w = e(o, {
        children: [a, t(g, {
          "aria-live": y ? "assertive" : void 0,
          children: y && "Page ".concat(c, " selected")
        })]
      });
    return t(r ? h : v, Object.assign({}, $, {
      children: w
    }));
  };
m.defaultProps = {
  total: 20,
  selectedPage: 10,
  surface: "light"
};
export { m as default };